// Generated by Melange

import * as Curry from "melange.js/curry.jsx";
import * as Fx from "../fx/fx.jsx";
import * as Stdlib__Option from "melange/option.jsx";
import * as Store__Player from "../store/player.jsx";

function make(newReplayGainOptions) {
  return Fx.Monad_syntax.let$star(Fx.ask(undefined), (function (param) {
    const store = param.store;
    const state = store.getState();
    const newReplayGainOptions$1 = Curry._1(newReplayGainOptions, state.player.replayGainOptions);
    const newReplayGainOptions_preAmp = Math.max(-15.0, Math.min(newReplayGainOptions$1.preAmp, 15.0));
    const newReplayGainOptions_preferredGain = newReplayGainOptions$1.preferredGain;
    const newReplayGainOptions$2 = {
      preAmp: newReplayGainOptions_preAmp,
      preferredGain: newReplayGainOptions_preferredGain
    };
    store.setState(function (prevState) {
      const init = prevState.player;
      return {
        albums: prevState.albums,
        artists: prevState.artists,
        auth: prevState.auth,
        player: {
          buffered: init.buffered,
          currentSongId: init.currentSongId,
          currentTime: init.currentTime,
          duration: init.duration,
          muted: init.muted,
          paused: init.paused,
          queuedSongIds: init.queuedSongIds,
          replayGainOptions: newReplayGainOptions$2,
          volume: init.volume
        },
        songs: prevState.songs
      };
    });
    return {
      TAG: /* Ok */ 0,
      _0: Stdlib__Option.iter((function (value) {
        localStorage.setItem(Store__Player.replay_gain_local_storage_key, value);
      }), JSON.stringify(newReplayGainOptions$2))
    };
  }));
}

export {
  make,
}
/* Store__Player Not a pure module */
